module.exports = __webpack_public_path__ + "media/images/soar/operation_group-26c76c7c08d1702abe3fbfc85d922fea.png";